"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalViewDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_dialog_confirmation_1 = require("@dzambalaorg/mui-dialog-confirmation");
const store_1 = require("../store");
const types_1 = require("../types");
const schemas_1 = require("../schemas");
const GlobalViewDialog = (props) => {
    const { externalDialogComponentSchema = {} } = props;
    const options = (0, store_1.useGlobalViewDialogStore)(state => state.options);
    const key = (0, store_1.useGlobalViewDialogStore)(state => state.key);
    const viewItem = (0, store_1.useGlobalViewDialogStore)(state => state.selectedItem);
    const closeDialog = (0, store_1.useGlobalViewDialogStore)(state => state.closeDialog);
    const open = key !== types_1.GlobalDialogKeys.DEFAULT;
    if (!open || !options) {
        return null;
    }
    const { componentProps = {}, onConfirm = closeDialog, onCancel = closeDialog, ...restDialogConfirmationProps } = options || {};
    return ((0, jsx_runtime_1.jsx)(mui_dialog_confirmation_1.ConfirmationDialog, { ...restDialogConfirmationProps, open: open, onConfirm: onConfirm, onCancel: onCancel, children: (0, schemas_1.renderComponent)(externalDialogComponentSchema, key, { ...componentProps, viewItem }) }));
};
exports.GlobalViewDialog = GlobalViewDialog;
//# sourceMappingURL=global-view.js.map